import PaymentView from '@/components/billing/PaymentView';
import Modal from '@/components/common/modals/Modal';
import { useSuccessToast } from '@/components/common/Toasts';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { useCurrentRateInfo } from '@common/react/rates';
import { useCurrentUser } from '@common/react/user';
import { TOASTS } from '@common/toasts';

interface PaymentModalProps {
    onComplete?: () => void;
    includeTrial: boolean;
}

export const showPaymentModal = (props: PaymentModalProps) =>
    ModalManager.show(PaymentModal, props);

const PaymentModal = ModalManager.create<PaymentModalProps>(
    ({ onComplete, includeTrial }) => {
        useTrackModalShown('Payment');

        const { currentRateInfo } = useCurrentRateInfo();
        const modal = useModal();
        const { membership } = useCurrentUser();
        const showSuccessToast = useSuccessToast();

        if (!currentRateInfo || !membership) return <></>;

        return (
            <Modal
                size="4xl"
                isOpen={modal.visible}
                scrollBehavior="outside"
                onClose={modal.hide}
                isCentered={true}
                modalBodyProps={{ p: 0 }}
            >
                <PaymentView
                    includeTrial={includeTrial}
                    onComplete={() => {
                        showSuccessToast(TOASTS.addPaymentMethodSuccess);
                        onComplete?.();
                    }}
                />
            </Modal>
        );
    }
);

export default PaymentModal;
